import { defineStore } from 'pinia';

export interface ServerDateState {
  date: Date;
}

export const useServerDateStore = defineStore('serverDate', {
  state: (): ServerDateState => ({
    date: new Date(),
  }),
  getters: {
    serverDate(state): Date {
      return state.date;
    },
    serverDateTimestamp(state): number {
      return new Date(state.date).getTime();
    },
  },
  actions: {
    setServerDate() {
      this.date = new Date();
    },
  },
});
